import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Checkbox,
  CheckboxGroup,
  Divider,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  Select,
  SelectItem,
  Tab,
  Tabs,
  Textarea,
  Chip,
  Input,
  Table,
  TableHeader,
  TableColumn,
  TableBody,
  TableRow,
  TableCell,
} from "@nextui-org/react";
import toast from "react-hot-toast";
import RootAdmin from "../../../../components/layouts/RootAdmin";
import { PencilSquareIcon, PlusIcon, TrashIcon, ExclamationTriangleIcon, MagnifyingGlassIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { useMemo, useState, useCallback, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import ModalAlert from "../../../../components/elements/ModalAlert";
import useCompany from "../../../../hooks/master-data/useCompany";
import ControlledReactSelect from "../../../../components/elements/ControlledReactSelect";
import ControlledInput from "../../../../components/elements/ControlledInput";
import { Controller, useFieldArray, useWatch } from "react-hook-form";
import { hasValidRole } from "../../../../services/helpers";
import useAuth from "../../../../hooks/useAuth";
import RolesAccess from "../../../../enums/roles";
import ClientDataGrid from "../../../../components/elements/ClientDataGrid";
import useListCompany from "../../../../hooks/useListCompany";
import TablePic from "../../../../components/fragments/admin/master-data/company/TablePic";
//import TableDocument from "../../../../components/fragments/admin/master-data/company/TableDocument";
import LocationInputWithPicker from "../../../../components/elements/LocationInputWithPicker";
import useSWR from "swr";
import { getFetcher, postFetcher } from "../../../../services/api";
import Cookies from "js-cookie";

export default function IndexPage() {
  const { roles, user } = useAuth();
  const [showOnlyNoB3Management, setShowOnlyNoB3Management] = useState(false);

  // Pass filter to useListCompany
  const { dataCompany, isLoadingCompany, mutate } = useListCompany({
    isTidakMelakukanPengelolaanB3: showOnlyNoB3Management ? true : undefined,
  });
  const navigate = useNavigate();

  // State untuk pencarian perusahaan
  const [searchMode, setSearchMode] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [isSearching, setIsSearching] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [showSearchResults, setShowSearchResults] = useState(false);
  const [selectedCompanyId, setSelectedCompanyId] = useState(null);
  const [showNotFoundDialog, setShowNotFoundDialog] = useState(false);
  const [companyNameResult, setCompanyNameResult] = useState("");
  const [, setDataParam] = useState("");

  // Cek role Pengelola
  const isPengelola = useMemo(() => {
    return hasValidRole(roles, [RolesAccess.PENGELOLA]);
  }, [roles]);

  // Cek role pengguna
  const isAdminOrPengelola = useMemo(() => {
    return hasValidRole(roles, [RolesAccess.PENGELOLA, RolesAccess.SUPER_ADMIN]);
  }, [roles]);

  // Cek apakah user adalah Pengelola dan tidak punya perusahaan
  const isPengelolaWithoutCompany = useMemo(() => {
    const hasCompany = user?.companies && user.companies.length > 0;
    return isPengelola && !hasCompany;
  }, [isPengelola, user]);

  /*
   * PERUSAHAAN YANG BARU MASUK DARI SIMPEL
   *
   * Akun SIMPEL yang pertama kali membuka aplikasi ini dibuatkan penggunanya
   * saja, tanpa perusahaan (lihat createNewUser di api/src/services/simpel.service.ts),
   * lalu diarahkan ke halaman ini. Sebelumnya ia masih harus melewati pencarian
   * NPWP/NIB dulu sebelum sampai ke form - padahal identitas perusahaannya sudah
   * dibawa dari SIMPEL dan dilengkapi backend saat penyimpanan lewat simpelAppKey.
   *
   * Jadi untuk kasus ini form langsung dibuka dan tahap pencarian dilewati.
   * Pengguna PENGELOLA yang TIDAK datang dari SIMPEL tidak berubah alurnya -
   * pencarian NPWP/NIB tetap jalan seperti biasa.
   */
  const dariSimpel = useMemo(() => !!Cookies.get("simpelToken"), []);
  const lewatiPencarianNpwp = dariSimpel && isPengelolaWithoutCompany;

  // State untuk alert update stok
  const [showStokAlert, setShowStokAlert] = useState(false);

  // State untuk alert update SK registrasi
  const [showSkRegistrationAlert, setShowSkRegistrationAlert] = useState(false);

  // Check localStorage untuk alert stok saat component mount
  useEffect(() => {
    if (isPengelola && user?.id) {
      const alertKey = `stok_alert_dismissed_${user.id}`;
      const isDismissed = localStorage.getItem(alertKey);

      // Tampilkan alert jika belum pernah di-dismiss
      if (!isDismissed) {
        setShowStokAlert(true);
      }
    }
  }, [isPengelola, user?.id]);

  // Check localStorage untuk alert SK registrasi saat component mount
  useEffect(() => {
    if (isPengelola && user?.id) {
      const shouldShowAlert = localStorage.getItem(`showSkRegistrationAlert_${user.id}`);
      if (shouldShowAlert === "true") {
        setShowSkRegistrationAlert(true);
      }
    }
  }, [isPengelola, user?.id]);

  // Handler untuk dismiss alert stok
  const handleDismissStokAlert = () => {
    if (user?.id) {
      const alertKey = `stok_alert_dismissed_${user.id}`;
      localStorage.setItem(alertKey, "true");
      setShowStokAlert(false);
    }
  };

  // Handler untuk navigate ke halaman SK registrasi
  const handleNavigateToSkRegistration = () => {
    // Hapus flag dari localStorage
    localStorage.removeItem(`showSkRegistrationAlert_${user?.id}`);
    setShowSkRegistrationAlert(false);
    // Navigate ke halaman registrasi
    navigate("/registrasi-b3/daftar");
  };

  // Handler untuk dismiss alert SK registrasi
  const handleDismissSkRegistrationAlert = () => {
    // Hapus flag dari localStorage
    localStorage.removeItem(`showSkRegistrationAlert_${user?.id}`);
    setShowSkRegistrationAlert(false);
  };

  const {
    isEdit,
    //loading,
    onClickEdit,
    onClickDelete,
    onSubmitDelete,
    onCloseForm,
    onSubmitForm,
    formError: { formErrorMessage },
    modalForm: { onOpenModalForm, isOpenModalForm, onOpenChangeModalForm },
    modalAlert: { isOpenModalAlert, onOpenChangeModalAlert },
    hookForm: {
      control,
      watch,
      register,
      handleSubmit,
      setValue,
      reset,
      formState: { errors, isSubmitting },
    },
    dataFetch: { province, regency, district, village, kbli },
    suratFile,
    setSuratFile,
    existingFilePath,
  } = useCompany({ mutate, selectedCompanyId, isPengelola });

  const tipePerusahaan = watch("tipePerusahaan");
  const jenisPelakuUsaha = watch("jenisPelakuUsaha");
  //const nomorInduk = watch("nomorInduk");
  const provinceIdValue = watch("provinceId");
  const regencyIdValue = watch("regencyId");
  const districtIdValue = watch("districtId");
  const tidakMelakukanPengelolaanB3 = watch("isTidakMelakukanPengelolaanB3");
  const idInduk = watch("idPerusahaanInduk");
  const idSimpel = watch("idCompanySimpel");
  const npwpValue = watch("npwp");
  const idPT = watch("id");

  // Blok penghubungan perusahaan ke PTSP (beserta tabel hasil pencariannya)
  // disembunyikan, dan form langsung dimulai dari input Nama Perusahaan, bila:
  //   1. checkbox "Menggunakan B3" dicentang - tipe ini tidak wajib memiliki
  //      perusahaan induk yang terdaftar di PTSP; atau
  //   2. checkbox "Tidak melakukan pengelolaan B3" dicentang - perusahaan tidak
  //      mengelola B3 sama sekali sehingga penghubungan ke PTSP tidak relevan.
  const hidePtspSection = useMemo(() => {
    if (tidakMelakukanPengelolaanB3) return true;
    if (!Array.isArray(tipePerusahaan)) return false;
    //return tipePerusahaan.includes("Menggunakan B3"); // Jika Menggunakan B3 + Distribusi B3 tidak perlu link PTSP
    return tipePerusahaan.length === 1 && tipePerusahaan[0] === "Menggunakan B3";
  }, [tipePerusahaan, tidakMelakukanPengelolaanB3]);

  // DEFINISI KONDISI REQUIRED BARU
  // Jika role super_admin, tidak wajib. Jika checkbox kelola B3 diklik, semuanya jadi opsional.
  const isStandardRequired = !hasValidRole(roles, [RolesAccess.SUPER_ADMIN]) && !tidakMelakukanPengelolaanB3;
  const isNpwpRequired = isStandardRequired && jenisPelakuUsaha !== "Instansi Pemerintah";

  // Clear bidang usaha when Instansi Pemerintah is selected
  useEffect(() => {
    if (jenisPelakuUsaha === "Instansi Pemerintah") {
      setValue("bidangUsaha", null);
    }
  }, [jenisPelakuUsaha, setValue]);

  const [, setCurrentPage] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");

  const [mainLocationData, setMainLocationData] = useState(null);
  const [mainIsMatchingLocation, setMainIsMatchingLocation] = useState(false);

  const findLocationMatch = useCallback((locationArray, searchName) => {
    if (!locationArray || !searchName) return null;

    return locationArray.find((item) => {
      const itemName = item.name.toLowerCase();
      const searchNameLower = searchName.toLowerCase();

      if (itemName === searchNameLower) return true;
      if (itemName.includes(searchNameLower) || searchNameLower.includes(itemName)) return true;

      const cleanItemName = itemName.replace(/^(kota|kabupaten|kab\.?|provinsi|prov\.?)\s+/i, "");
      const cleanSearchName = searchNameLower.replace(/^(kota|kabupaten|kab\.?|provinsi|prov\.?)\s+/i, "");

      return cleanItemName === cleanSearchName || cleanItemName.includes(cleanSearchName) || cleanSearchName.includes(cleanItemName);
    });
  }, []);

  // Handler untuk form utama saja
  const handleMainLocationDataReceived = useCallback(
    (data) => {
      setMainLocationData(data);
      console.log("Main form received location data:", data);

      setValue("provinceId", "");
      setValue("regencyId", "");
      setValue("districtId", "");
      setValue("villageId", "");

      setMainIsMatchingLocation(true);
    },
    [setValue],
  );

  // useEffect untuk matching province form utama
  useEffect(() => {
    if (mainLocationData && province && province.length > 0 && mainIsMatchingLocation) {
      console.log("Main form matching province...", { locationData: mainLocationData.province, provinceData: province });

      const matchedProvince = findLocationMatch(province, mainLocationData.province);

      if (matchedProvince) {
        console.log("Main form setting province:", matchedProvince.name, "ID:", matchedProvince.id);
        setValue("provinceId", matchedProvince.id.toString());
      } else {
        console.log("Main form province not found:", mainLocationData.province);
        setMainIsMatchingLocation(false);
      }
    }
  }, [mainLocationData, province, mainIsMatchingLocation, findLocationMatch, setValue]);

  // useEffect untuk matching regency form utama
  useEffect(() => {
    if (mainLocationData && mainLocationData.regency && regency && regency.length > 0 && mainIsMatchingLocation && provinceIdValue) {
      console.log("Main form matching regency...", { locationData: mainLocationData.regency, regencyData: regency });

      const matchedRegency = findLocationMatch(regency, mainLocationData.regency);

      if (matchedRegency) {
        console.log("Main form setting regency:", matchedRegency.name, "ID:", matchedRegency.id);
        setValue("regencyId", matchedRegency.id.toString());
        setMainIsMatchingLocation(false);
      } else {
        console.log("Main form regency not found:", mainLocationData.regency);
        setMainIsMatchingLocation(false);
      }
    }
  }, [mainLocationData, regency, mainIsMatchingLocation, provinceIdValue, findLocationMatch, setValue]);

  const handleSearchChange = useCallback((event) => {
    setSearchQuery(event.target.value);
    setCurrentPage(0);
  }, []);

  const filteredCompanies = useMemo(() => {
    if (!dataCompany?.data) {
      return [];
    }
    // Filter hanya berdasarkan search query, filter B3 sudah di-handle di API
    return dataCompany.data.filter((company) => company.name.toLowerCase().includes(searchQuery.toLowerCase()));
  }, [dataCompany?.data, searchQuery]);

  // Handler untuk mencari perusahaan berdasarkan NPWP/NIB
  const handleSearchCompany = async (termParam) => {
    // termParam dipakai tombol "Hubungkan" agar tidak membaca state
    // searchTerm yang belum sempat ter-update pada saat klik.
    const term = (typeof termParam === "string" ? termParam : searchTerm) || "";
    if (!term.trim()) {
      toast.error("NPWP atau NIB harus diisi");
      return;
    }

    setIsSearching(true);
    try {
      const response = await getFetcher(`/api/company/search-by-npwp-nib/${term.trim()}`);

      if (response && response.length > 0) {
        setSearchResults(response);
        setShowSearchResults(true);
      } else {
        // Tampilkan dialog
        setShowNotFoundDialog(true);
        setSearchResults([]);
        setShowSearchResults(false);
      }
    } catch (error) {
      console.error("Error searching company:", error);
      // Tampilkan dialog jika error
      setShowNotFoundDialog(true);
      setSearchResults([]);
      setShowSearchResults(false);
    } finally {
      setIsSearching(false);
    }
  };

  // Handler untuk mencari nama perusahaan berdasarkan idCompany / idInduk
  const handleGetNamebyIdInduk = async (idIndukParam) => {
    if (!idIndukParam) {
      toast.error("idPerusahaanInduk tidak ada !!!");
      return;
    }

    setIsSearching(true);
    try {
      const response = await getFetcher(`/api/company/search-name-by-id/${idIndukParam}`);
      console.log("Cek Response API:", response);

      if (response?.success && response?.data?.companyName) {
        setCompanyNameResult(response.data.companyName);
      } 
      else if (response?.companyName) {
        setCompanyNameResult(response.companyName);
      } 
      else {
        setCompanyNameResult(""); 
      }
    } catch (error) {
      console.error("Error fetching company name by ID Induk:", error);
      setCompanyNameResult(""); 
    } finally {
      setIsSearching(false);
    }
  };

  useEffect(() => {
    if (idInduk) {
      handleGetNamebyIdInduk(idInduk);
    }
  }, [idInduk]);

  // Handler untuk confirm manual creation dari dialog
  const handleConfirmManualCreation = () => {
    setShowNotFoundDialog(false);
    // Set searchMode false agar form langsung ditampilkan
    setSearchMode(false);
    setSearchTerm("");
    setSearchResults([]);
    setShowSearchResults(false);
    setSelectedCompanyId(null);
    reset({
      name: "",
      penanggungJawab: "",
      tipePerusahaan: [],
      skalaPerusahaan: null,
      alamatKantor: "",
      telpKantor: "",
      faxKantor: "",
      emailKantor: "",
      npwp: "",
      idCompanySimpel: "",
      idPerusahaanInduk: "",
      bidangUsaha: [],
      jenisPelakuUsaha: "",
      proper: "",
      nomorInduk: "",
      companyLokasiKegiatan: [],
      latitude: null,
      longitude: null,
      provinceId: "",
      regencyId: "",
      districtId: "",
      villageId: "",
    });
    // Buka modal setelah state di-reset
    onOpenModalForm();
  };

  // Handler untuk memilih perusahaan dari hasil pencarian
  const handleSelectCompany = async (company) => {
    try {
      setIsSearching(true);

      // Get SIMPEL token from cookies
      const simpelToken = Cookies.get("simpelToken");

      if (isEdit) {
        const response = await postFetcher(`/api/company/update-induk/${idPT}`, {
          searchCompanyId: company.id,
          simpelAppKey: simpelToken || undefined,
        });

        console.log("API Response: ", response);

        // Tutup hasil pencarian
        setSearchMode(false);
        setShowSearchResults(false);

        if (response?.success) {
          mutate();
          handleCloseForm(); 
          toast.success(`Perusahaan berhasil di hubungkan dengan ${response.data.name}`);
        }

      } else {
        const response = await postFetcher(`/api/company/select-company/${company.id}`, {
          simpelAppKey: simpelToken || undefined,
        });

        const newCompany = response.company;
        setSelectedCompanyId(newCompany.id);

        setSearchMode(false);
        setShowSearchResults(false);
        mutate();
        onClickEdit(newCompany);

        toast.success("Perusahaan berhasil terhubung! Silakan lengkapi data perusahaan.");
      }
    } catch (error) {
      console.error("Error selecting company:", error);
      toast.error(error.response?.data?.message || "Gagal memproses data perusahaan");
    } finally {
      setIsSearching(false);
    }
  };

  // Handler saat modal dibuka untuk tambah perusahaan
  const handleOpenAddModal = () => {
    // Hanya set searchMode true untuk role PENGELOLA, dan tidak untuk pendatang
    // baru dari SIMPEL yang memang dilewatkan tahap pencarian NPWP/NIB.
    setSearchMode(isPengelola && !lewatiPencarianNpwp);
    setSearchTerm("");
    setSearchResults([]);
    setShowSearchResults(false);
    setSelectedCompanyId(null);
    reset({
      name: "",
      penanggungJawab: "", // Required in DB - empty string default
      tipePerusahaan: [], // Required in DB - empty array default
      skalaPerusahaan: null,
      alamatKantor: "", // Required in DB - empty string default
      telpKantor: "", // Required in DB - empty string default
      faxKantor: "",
      emailKantor: "",
      npwp: "",
      idCompanySimpel: "",
      idPerusahaanInduk: "",
      bidangUsaha: [],
      jenisPelakuUsaha: "",
      proper: "",
      nomorInduk: "",
      companyLokasiKegiatan: [],
      latitude: null,
      longitude: null,
      provinceId: "",
      regencyId: "",
      districtId: "",
      villageId: "",
    });
    onOpenModalForm();
  };

  /*
   * Pendatang baru dari SIMPEL langsung disodori formnya, tanpa perlu menekan
   * tombol apa pun - itulah "diarahkan ke update profil" yang dimaksud.
   *
   * Dijaga ref supaya hanya sekali per kunjungan halaman: kalau pengguna menutup
   * form, ia tidak dibuka paksa lagi.
   */
  const formAwalSudahDibuka = useRef(false);

  useEffect(() => {
    if (!lewatiPencarianNpwp || formAwalSudahDibuka.current) return;
    formAwalSudahDibuka.current = true;
    handleOpenAddModal();
    // handleOpenAddModal sengaja tidak masuk daftar dependensi: fungsinya dibuat
    // ulang setiap render, sedangkan efek ini memang hanya boleh jalan sekali.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lewatiPencarianNpwp]);

  // Override onCloseForm untuk reset state pencarian
  const handleCloseForm = () => {
    setSearchMode(true);
    setSearchTerm("");
    setSearchResults([]);
    setShowSearchResults(false);
    setSelectedCompanyId(null);
    onCloseForm();
  };

  const columns = useMemo(
    () => [
      { field: "name", headerName: "Nama Perusahaan" },
      { field: "penanggungJawab", headerName: "Penanggung Jawab" },
      { field: "alamatKantor", headerName: "Alamat Kantor" },
      { field: "telpKantor", headerName: "Telp Kantor" },
      { field: "faxKantor", headerName: "Fax Kantor" },
      { field: "emailKantor", headerName: "Email Kantor" },
      { field: "npwp", headerName: "NPWP" },
      { field: "companyLokasiKegiatan", headerName: "Lokasi Kegiatan", renderCell: (params) => params.row.companyLokasiKegiatan?.map((item) => item.namaLokasiKegiatan).join(", ") || "-" },
      { field: "tipePerusahaan", headerName: "Tipe Perusahaan", renderCell: (params) => params.row.tipePerusahaan.map((item) => item).join(", ") },
      { field: "skalaPerusahaan", headerName: "Skala Perusahaan", valueGetter: (value, row) => row.skalaPerusahaan ?? "-" },
      { field: "bidangUsaha", headerName: "Bidang Usaha" },
      { field: "nomorInduk", headerName: "Nomor Induk Berusaha" },
      { field: "idCompanySimpel", headerName: "Nomor Id SIMPEL" },
      { field: "idPerusahaanInduk", headerName: "Induk/Group Perusahaan" },
      {
        field: "action",
        headerName: "Aksi",
        renderCell: (params) => (
          <div className="flex items-center gap-1">
            <Button size="sm" onPress={() => onClickEdit(params.row)} color="warning" startContent={setDataParam(params.row)} isIconOnly>
              <PencilSquareIcon className="size-4" />
            </Button>
            {hasValidRole(roles, [RolesAccess.SUPER_ADMIN, RolesAccess.PIC_PELAPORAN]) && (
              <Button size="sm" onPress={() => onClickDelete(params.row.id)} color="danger" isIconOnly>
                <TrashIcon className="size-4" />
              </Button>
            )}
          </div>
        ),
        sortable: false,
        filterable: false,
      },
    ],
    [onClickEdit, onClickDelete, roles],
  );

  return (
    <RootAdmin>
      <Card className="w-full mt-3" radius="sm">
        <CardHeader>
          <p className="text-md">Daftar Perusahaan</p>
        </CardHeader>
        <Divider />
        <CardBody>
          {/* Alert untuk Pengelola tanpa perusahaan */}
          {isPengelolaWithoutCompany && (
            <div className="mb-4 p-4 bg-warning-50 border-l-4 border-warning-500 rounded-r-lg">
              <div className="flex items-start gap-3">
                <ExclamationTriangleIcon className="size-6 text-warning-600 flex-shrink-0 mt-0.5" />
                <div className="flex-1">
                  <h3 className="text-sm font-semibold text-warning-800 mb-1">Akun Belum Terhubung dengan Perusahaan</h3>
                  <p className="text-sm text-warning-700">Untuk mengakses fitur lengkap aplikasi, silakan tambahkan perusahaan anda.</p>
                </div>
              </div>
            </div>
          )}

          {/* Alert untuk Update Stok B3 */}
          {isPengelola && showStokAlert && (
            <div className="mb-4 p-4 bg-blue-50 border-l-4 border-blue-500 rounded-r-lg">
              <div className="flex items-start gap-3">
                <ExclamationTriangleIcon className="size-6 text-blue-600 flex-shrink-0 mt-0.5" />
                <div className="flex-1">
                  <h3 className="text-sm font-semibold text-blue-800 mb-1">Update Stok B3 Anda</h3>
                  <p className="text-sm text-blue-700 mb-3">
                    Jangan lupa untuk mengupdate stok B3 perusahaan Anda agar data selalu akurat.
                    {isPengelolaWithoutCompany && " Silakan tambahkan perusahaan terlebih dahulu sebelum mengupdate stok."}
                  </p>
                  <div className="flex gap-2">
                    <Button size="sm" color="primary" onPress={() => navigate("/gudang/stok-b3")} isDisabled={isPengelolaWithoutCompany}>
                      Update Stok B3
                    </Button>
                    <Button size="sm" variant="light" color="default" onPress={handleDismissStokAlert} startContent={<XMarkIcon className="size-4" />}>
                      Jangan Tampilkan Lagi
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Alert untuk Update SK Registrasi setelah tambah perusahaan pertama kali */}
          {showSkRegistrationAlert && (
            <div className="mb-4 p-4 bg-green-50 border-l-4 border-green-500 rounded-r-lg">
              <div className="flex items-start gap-3">
                <svg className="size-6 text-green-600 flex-shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <div className="flex-1">
                  <h3 className="text-sm font-semibold text-green-800 mb-1">Perusahaan Berhasil Ditambahkan!</h3>
                  <p className="text-sm text-green-700 mb-3">Sekarang Anda dapat mengupdate daftar SK registrasi perusahaan Anda dari perusahaan induk.</p>
                  <div className="flex gap-2">
                    <Button size="sm" color="success" onPress={handleNavigateToSkRegistration}>
                      Update Daftar SK Registrasi
                    </Button>
                    <Button size="sm" variant="light" color="default" onPress={handleDismissSkRegistrationAlert}>
                      Nanti Saja
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          )}

          <Tabs
            color="primary"
            variant="underlined"
            aria-label="tabs"
            classNames={{
              tabList: "gap-6 w-full relative rounded-none p-0 border-b border-divider",
              cursor: "w-full",
              tab: "max-w-fit px-1.5 h-12",
              tabContent: "group-data-[selected=true]:font-semibold",
            }}
            disabledKeys={isPengelolaWithoutCompany ? ["2", "3"] : []}
          >
            <Tab key="1" title="Perusahaan">
              <div className="mb-5" style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: "15px" }}>
                {(!isPengelola || isPengelolaWithoutCompany) && (
                  <Button onPress={handleOpenAddModal} size="md" color="primary" startContent={<PlusIcon className="size-4 stroke-2" />}>
                    {isPengelola ? "Update Perusahaan" : "Tambah"}
                  </Button>
                )}
                <SearchField className="ml-5" value={searchQuery} onChange={handleSearchChange} placeholder="Cari Perusahaan" />
                {hasValidRole(roles, [RolesAccess.SUPER_ADMIN]) && (
                  <Checkbox size="sm" isSelected={showOnlyNoB3Management} onValueChange={setShowOnlyNoB3Management}>
                    <span className="text-sm">Hanya tampilkan perusahaan yang tidak melakukan pengelolaan B3</span>
                  </Checkbox>
                )}
              </div>

              <div className="h-[500px]">
                <ClientDataGrid
                  columns={columns}
                  rows={filteredCompanies}
                  isLoading={isLoadingCompany}
                  initialState={{
                    columns: {
                      columnVisibilityModel: {
                        skalaPerusahaan: false,
                        tipePerusahaan: false,
                        telpKantor: false,
                        faxKantor: false,
                        emailKantor: false,
                        npwp: false,
                        companyLokasiKegiatan: false,
                        bidangUsaha: false,
                        nomorInduk: false,
                        idCompanySimpel: false,
                        idPerusahaanInduk: false,
                      },
                    },
                  }}
                />
              </div>
            </Tab>
            <Tab
              key="3"
              title={
                <div className="flex items-center gap-2">
                  <span>Penanggung Jawab</span>
                  {isPengelolaWithoutCompany && (
                    <Chip size="sm" color="warning" variant="flat">
                      Terkunci
                    </Chip>
                  )}
                </div>
              }
            >
              <TablePic />
            </Tab>
          </Tabs>
        </CardBody>
      </Card>

      <ModalAlert isOpen={isOpenModalAlert} onOpenChange={onOpenChangeModalAlert} onSubmit={onSubmitDelete} icon="danger" />
      <Modal scrollBehavior="inside" size="5xl" isOpen={isOpenModalForm} onOpenChange={onOpenChangeModalForm} onClose={handleCloseForm} isDismissable={false} isKeyboardDismissDisabled={false}>
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader>{isEdit ? "Ubah" : "Tambah"} Perusahaan</ModalHeader>
              <ModalBody>
                {formErrorMessage && (
                  <ul className="text-xs text-white bg-danger p-3">
                    {Object.entries(formErrorMessage).map(([key, value]) => (
                      <li key={key}>{value}</li>
                    ))}
                  </ul>
                )}

                {/* Mode Pencarian Perusahaan (hanya untuk tambah baru dan role PENGELOLA) */}
                {!isEdit && searchMode && isPengelola && !hidePtspSection && (
                  <div className="mb-6">
                    <div className="p-4 bg-blue-50 border border-blue-200 rounded-lg mb-4">
                      <h3 className="text-sm font-semibold text-blue-800 mb-2">Cari Perusahaan Berdasarkan NPWP/NIB</h3>
                      <p className="text-xs text-blue-700 mb-3">Masukkan NPWP atau NIB untuk mencari perusahaan yang sudah terdaftar</p>

                      <div className="flex gap-2">
                        <Input
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                          placeholder="Masukkan NPWP atau NIB..."
                          variant="bordered"
                          onKeyPress={(e) => {
                            if (e.key === "Enter") {
                              handleSearchCompany();
                            }
                          }}
                        />
                        <Button color="primary" onPress={() => handleSearchCompany()} isLoading={isSearching} startContent={!isSearching && <MagnifyingGlassIcon className="size-4" />}>
                          Cari
                        </Button>
                      </div>
                    </div>

                    {/* Hasil Pencarian */}
                    {showSearchResults && (
                      <div className="border border-line rounded-lg overflow-hidden">
                        <div className="bg-surface-2 p-3 border-b">
                          <h4 className="text-sm font-semibold">Hasil Pencarian ({searchResults.length} perusahaan ditemukan)</h4>
                        </div>
                        <div className="max-h-96 overflow-y-auto">
                          <Table aria-label="Search Results">
                            <TableHeader>
                              <TableColumn>NAMA PERUSAHAAN</TableColumn>
                              <TableColumn>NPWP</TableColumn>
                              <TableColumn>NIB</TableColumn>
                              <TableColumn>ALAMAT</TableColumn>
                              <TableColumn>JUMLAH REGISTRASI</TableColumn>
                              <TableColumn>AKSI</TableColumn>
                            </TableHeader>
                            <TableBody>
                              {searchResults.map((company) => (
                                <TableRow key={company.id}>
                                  <TableCell>{company.name}</TableCell>
                                  <TableCell>{company.npwp || "-"}</TableCell>
                                  <TableCell>{company.nib || company.nomorInduk || "-"}</TableCell>
                                  <TableCell className="max-w-xs truncate">{company.alamatKantor || "-"}</TableCell>
                                  <TableCell>
                                    <Chip size="sm" color="primary" variant="flat">
                                      {company._count?.registrasi || 0}
                                    </Chip>
                                  </TableCell>
                                  <TableCell>
                                    <Button size="sm" color="success" onPress={() => handleSelectCompany(company)}>
                                      Pilih
                                    </Button>
                                  </TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </div>
                      </div>
                    )}
                  </div>
                )}

                {/* Form Lengkap (tampil saat mode edit atau setelah perusahaan tidak ditemukan) */}                
                {(isEdit || !searchMode || hidePtspSection) && (
                  <form onSubmit={handleSubmit((data) => onSubmitForm(data, suratFile))}>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-6">

                      {isAdminOrPengelola && isEdit && !hidePtspSection && (
                        <div className="col-span-2">
                          <div className="p-4 bg-blue-50 border border-blue-200 rounded-lg mb-4">
                            
                            {idInduk ? (
                              <h3 className="text-sm font-semibold text-blue-800 mb-2">
                                Perusahaan sudah terhubung dengan perusahaan di PTSP ({ companyNameResult || idInduk})
                              </h3>
                            ) : idSimpel ? (
                              <div>
                                <h3 className="text-sm font-semibold text-red-800 mb-2">
                                  Perusahaan belum terhubung dengan perusahaan induk yang terdaftar di PTSP.<br/>
                                  Silahkan masukkan NPWP dari perusahaan yang terdaftar di PTSP atau menggunakan NPWP berikut:<br/>
                                  (Abaikan jika perusahaan hanya <b>menggunakan B3</b> atau <b>tidak melakukan pengelolaan B3</b>)
                                </h3>
                                <div className="flex gap-2">
                                  {/* Update NPWP isRequired */}
                                  <ControlledInput control={control} name="npwp" isRequired={isNpwpRequired} />
                                  <Button color="primary" label="PTSP" onPress={() => { setSearchTerm(npwpValue || ""); handleSearchCompany(npwpValue); }} isLoading={isSearching} startContent={!isSearching && <MagnifyingGlassIcon className="size-4" />}>
                                    Hubungkan
                                  </Button>
                                </div>
                              </div>
                            ) : null } 

                            {/* Hasil Pencarian */}
                            {showSearchResults && (
                              <div className="border border-line rounded-lg overflow-hidden">
                                <div className="bg-surface-2 p-3 border-b">
                                  <h4 className="text-sm font-semibold">Hasil Pencarian ({searchResults.length} perusahaan ditemukan)</h4>
                                </div>
                                <div className="max-h-96 overflow-y-auto">
                                  <Table aria-label="Search Results">
                                    <TableHeader>
                                      <TableColumn>NAMA PERUSAHAAN</TableColumn>
                                      <TableColumn>NPWP</TableColumn>
                                      <TableColumn>NIB</TableColumn>
                                      <TableColumn>ALAMAT</TableColumn>
                                      <TableColumn>JUMLAH REGISTRASI</TableColumn>
                                      <TableColumn>AKSI</TableColumn>
                                    </TableHeader>
                                    <TableBody>
                                      {searchResults.map((company) => (
                                        <TableRow key={company.id}>
                                          <TableCell>{company.name}</TableCell>
                                          <TableCell>{company.npwp || "-"}</TableCell>
                                          <TableCell>{company.nib || company.nomorInduk || "-"}</TableCell>
                                          <TableCell className="max-w-xs truncate">{company.alamatKantor || "-"}</TableCell>
                                          <TableCell>
                                            <Chip size="sm" color="primary" variant="flat">
                                              {company._count?.registrasi || 0}
                                            </Chip>
                                          </TableCell>
                                          <TableCell>
                                            <Button size="sm" color="success" onPress={() => handleSelectCompany(company)} >
                                              Pilih
                                            </Button>
                                          </TableCell>
                                        </TableRow>
                                      ))}
                                    </TableBody>
                                  </Table>
                                </div>
                              </div>
                            )}
                            
                          </div>
                        </div>
                      )}

                      <ControlledInput control={control} name="name" label="Nama Perusahaan" isRequired={!tidakMelakukanPengelolaanB3} />
                      <div className="flex gap-2">
                        <ControlledInput control={control} name="penanggungJawab" label="Nama Penanggung Jawab" isRequired={isStandardRequired} />
                        <ControlledInput control={control} name="idCompanySimpel" label="ID User SIMPEL" isRequired={isStandardRequired} />
                      </div>

                      {/* Checkbox Tidak Melakukan Pengelolaan B3 */}
                      <div className="col-span-2">
                        <Controller
                          control={control}
                          name="isTidakMelakukanPengelolaanB3"
                          render={({ field }) => (
                            <Checkbox
                              {...field}
                              isSelected={field.value}
                              onValueChange={(checked) => {
                                field.onChange(checked);
                                if (checked) {
                                  // Clear tipe perusahaan when checked
                                  setValue("tipePerusahaan", []);
                                } else {
                                  setSuratFile(null);
                                }
                              }}
                              size="sm"
                            >
                              <span className="text-sm font-medium">Tidak melakukan pengelolaan B3</span>
                            </Checkbox>
                          )}
                        />
                      </div>

                      {/* File Upload untuk Surat Tidak Melakukan Pengelolaan B3 */}
                      {tidakMelakukanPengelolaanB3 && (
                        <div className="col-span-2">
                          <div className="border-2 border-dashed border-line-strong rounded-lg p-4">
                            <div className="flex items-center justify-between mb-3">
                              <div>
                                <h4 className="text-sm font-semibold text-ink-700">Surat Pernyataan Tidak Melakukan Pengelolaan B3</h4>
                                <p className="text-xs text-ink-500 mt-1">{isPengelola ? "Wajib mengupload surat pernyataan" : "Upload surat pernyataan (opsional)"}</p>
                              </div>
                              <Button
                                size="sm"
                                color="primary"
                                variant="flat"
                                onPress={() => {
                                  // Download template - bisa disesuaikan dengan URL template yang ada
                                  window.open("/client/uploads/document/template-surat-tidak-kelola-b3.pdf", "_blank");
                                }}
                              >
                                Download Template
                              </Button>
                            </div>

                            {/* Tampilkan tombol lihat file yang sudah ada (saat edit) */}
                            {isEdit && existingFilePath && (
                              <div className="mb-3 p-3 bg-blue-50 border border-blue-200 rounded-lg">
                                <div className="flex items-center justify-between">
                                  <div className="flex items-center gap-2">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 text-blue-600">
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"
                                      />
                                    </svg>
                                    <div>
                                      <p className="text-sm font-medium text-blue-700">File Tersimpan</p>
                                      <p className="text-xs text-blue-600">{existingFilePath.split("/").pop()}</p>
                                    </div>
                                  </div>
                                  <Button
                                    size="sm"
                                    color="primary"
                                    variant="solid"
                                    onPress={() => {
                                      let apiBaseUrl = process.env.REACT_APP_API_BASE_URL || "http://localhost:3002";
                                      apiBaseUrl = apiBaseUrl.replace(/\/$/, "");
                                      const filePath = existingFilePath.startsWith("/") ? existingFilePath : `/${existingFilePath}`;
                                      const fullUrl = `${apiBaseUrl}${filePath}`;
                                      window.open(fullUrl, "_blank");
                                    }}
                                    startContent={
                                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-4">
                                        <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"
                                        />
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                      </svg>
                                    }
                                  >
                                    Lihat File
                                  </Button>
                                </div>
                              </div>
                            )}

                            <div className={isEdit && existingFilePath ? "mt-2" : ""}>
                              <label className="text-xs text-ink-500 mb-1 block">{isEdit && existingFilePath ? "Upload file baru untuk mengganti" : "Upload file"}</label>
                              <Input
                                type="file"
                                accept=".pdf,.doc,.docx"
                                onChange={(e) => {
                                  const file = e.target.files?.[0];
                                  if (file) {
                                    if (file.size > 5 * 1024 * 1024) {
                                      toast.error("Ukuran file maksimal 5MB");
                                      e.target.value = "";
                                      return;
                                    }
                                    setSuratFile(file);
                                    toast.success(`File ${file.name} siap diupload`);
                                  }
                                }}
                                variant="bordered"
                                size="sm"
                              />
                            </div>
                            {suratFile && (
                              <div className="mt-2 p-2 bg-green-50 border border-green-200 rounded">
                                <p className="text-xs text-green-700">
                                  File terpilih: <span className="font-semibold">{suratFile.name}</span>
                                </p>
                              </div>
                            )}
                            {isPengelola && !suratFile && !existingFilePath && <p className="text-xs text-danger mt-2">* File surat wajib diupload untuk role Pengelola</p>}
                          </div>
                        </div>
                      )}

                      <div className="col-span-2">
                        <Controller
                          control={control}
                          name="tipePerusahaan"
                          render={({ field, fieldState }) => (
                            <CheckboxGroup
                              {...field}
                              label="Tipe Perusahaan"
                              isRequired={isStandardRequired}
                              isInvalid={fieldState.invalid}
                              errorMessage={fieldState.error?.message}
                              isDisabled={tidakMelakukanPengelolaanB3}
                            >
                              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                <Checkbox size="sm" value="Impor B3" classNames={{ base: "hover:bg-green-100 p-2 rounded-lg transition-colors cursor-pointer w-full max-w-full", wrapper: "bg-line border-line-strong dark:bg-gray-700" }}>
                                  <div className="flex flex-col">
                                    <span>Importir B3</span>
                                    <span className="text-xs text-ink-500">Wajib dipilih apabila perusahaan melakukan pembelian B3 melalui impor (Importir).</span>
                                  </div>
                                </Checkbox>
                                <Checkbox size="sm" value="Distribusi B3" classNames={{ base: "hover:bg-green-100 p-2 rounded-lg transition-colors cursor-pointer w-full max-w-full", wrapper: "bg-line border-line-strong dark:bg-gray-700" }}>
                                  <div className="flex flex-col">
                                    <span>Distribusi B3</span>
                                    <span className="text-xs text-ink-500">Wajib dipilih apabila perusahaan melakukan distribusi B3 kepada pelanggan (customer).</span>
                                  </div>
                                </Checkbox>
                                <Checkbox size="sm" value="Menggunakan B3" classNames={{ base: "hover:bg-green-100 p-2 rounded-lg transition-colors cursor-pointer w-full max-w-full", wrapper: "bg-line border-line-strong dark:bg-gray-700" }}>
                                  <div className="flex flex-col">
                                    <span>Menggunakan B3</span>
                                    <span className="text-xs text-ink-500">Wajib dipilih apabila perusahaan melakukan penggunaan B3 dan/atau pembelian B3 dari dalam negeri (lokal).</span>
                                  </div>
                                </Checkbox>
                                <Checkbox size="sm" value="Produksi B3" classNames={{ base: "hover:bg-green-100 p-2 rounded-lg transition-colors cursor-pointer w-full max-w-full", wrapper: "bg-line border-line-strong dark:bg-gray-700" }}>
                                  <div className="flex flex-col">
                                    <span>Produksi B3</span>
                                    <span className="text-xs text-ink-500">Wajib dipilih apabila perusahaan melakukan produksi B3.</span>
                                  </div>
                                </Checkbox>
                                <Checkbox size="sm" value="Mengangkut B3" classNames={{ base: "hover:bg-green-100 p-2 rounded-lg transition-colors cursor-pointer w-full max-w-full", wrapper: "bg-line border-line-strong dark:bg-gray-700" }}>
                                  <div className="flex flex-col">
                                    <span>Mengangkut B3</span>
                                    <span className="text-xs text-ink-500">Wajib dipilih apabila perusahaan berperan sebagai pengangkut B3.</span>
                                  </div>
                                </Checkbox>
                              </div>
                            </CheckboxGroup>
                          )}
                        />
                      </div>

                      <ControlledReactSelect
                        control={control}
                        name="skalaPerusahaan"
                        label="Skala Perusahaan"
                        menuPosition="absolute"
                        isMulti={false}
                        isLoading={false}
                        isRequired={isStandardRequired}
                        options={[
                          { value: "Mikro", label: "Mikro" },
                          { value: "Kecil", label: "Kecil" },
                          { value: "Menengah", label: "Menengah" },
                          { value: "Besar", label: "Besar" },
                          { value: "Kantor perwakilan", label: "Kantor Perwakilan" },
                          { value: "Badan usaha luar negeri", label: "Badan Usaha Luar Negeri" },
                        ]}
                        className="col-span-2 md:col-span-1"
                      />

                      <Textarea
                        {...register("alamatKantor")}
                        isRequired={isStandardRequired}
                        variant="faded"
                        type="text"
                        label="Alamat Kantor"
                        labelPlacement="outside"
                        color={errors.alamatKantor ? "danger" : "default"}
                        isInvalid={errors.alamatKantor}
                        errorMessage={errors.alamatKantor && errors.alamatKantor.message}
                        className="col-span-2"
                      />

                      <ControlledInput control={control} name="telpKantor" label="Telepon Kantor" isRequired={isStandardRequired} />
                      <ControlledInput control={control} name="faxKantor" label="Fax Kantor" isRequired={isStandardRequired} />
                      <ControlledInput control={control} name="emailKantor" label="Email Kantor" isRequired={isStandardRequired} />
                      <ControlledInput control={control} name="npwp" label="NPWP" isRequired={isNpwpRequired} />
                      
                      <ControlledReactSelect
                        control={control}
                        name="bidangUsaha"
                        label="Bidang Usaha / KBLI"
                        menuPosition="absolute"
                        isMulti={true}
                        isLoading={!kbli}
                        options={
                          kbli?.map((item) => ({
                            value: item.kode,
                            label: `${item.kode} - ${item.judul}`,
                          })) || []
                        }
                        isRequired={isNpwpRequired}
                        isDisabled={jenisPelakuUsaha === "Instansi Pemerintah"}
                      />
                      
                      <Select
                        {...register("jenisPelakuUsaha")}
                        isRequired={isStandardRequired}
                        variant="faded"
                        menuPosition="absolute"
                        label="Jenis Pelaku Usaha / Kegiatan"
                        labelPlacement="outside"
                        placeholder="Pilih..."
                        color={errors.jenisPelakuUsaha ? "danger" : "default"}
                        isInvalid={errors.jenisPelakuUsaha}
                        errorMessage={errors.jenisPelakuUsaha && errors.jenisPelakuUsaha.message}
                      >
                        <SelectItem key="Berusaha" value="Berusaha">
                          Berusaha
                        </SelectItem>
                        <SelectItem key="Instansi Pemerintah" value="Instansi Pemerintah">
                          Instansi Pemerintah
                        </SelectItem>
                      </Select>
                      
                      <Select
                        {...register("proper")}
                        variant="faded"
                        label="PROPER / NON PROPER"
                        labelPlacement="outside"
                        placeholder="Pilih..."
                        color={errors.proper ? "danger" : "default"}
                        isInvalid={errors.proper}
                        errorMessage={errors.proper && errors.proper.message}
                        isDisabled={!hasValidRole(roles, [RolesAccess.SUPER_ADMIN])}
                      >
                        <SelectItem key="PROPER" value="PROPER">
                          PROPER
                        </SelectItem>
                        <SelectItem key="NON PROPER" value="NON PROPER">
                          NON PROPER
                        </SelectItem>
                      </Select>
                      
                      <ControlledInput control={control} name="nomorInduk" label="Nomor Induk Berusaha (NIB)" isRequired={isNpwpRequired} />
                      
                      <div className="col-span-2">
                        <LocationInputWithPicker
                          key="main-form"
                          control={control}
                          setValue={setValue}
                          latitudeName="latitude"
                          longitudeName="longitude"
                          onLocationDataReceived={handleMainLocationDataReceived}
                          province={province}
                          regency={regency}
                          district={district}
                          village={village}
                        />
                      </div>
                      
                      <ControlledReactSelect
                        control={control}
                        name="provinceId"
                        label="Provinsi"
                        options={province?.map((item) => ({ value: item.id, label: item.name }))}
                        isLoading={!province}
                        isRequired={isStandardRequired}
                        onChange={(selectedOption) => {
                          setValue("regencyId", "");
                          setValue("districtId", "");
                          setValue("villageId", "");
                        }}
                      />
                      <ControlledReactSelect
                        control={control}
                        name="regencyId"
                        label="Kabupaten / Kota"
                        options={regency?.map((item) => ({ value: item.id, label: item.name }))}
                        isLoading={!regency}
                        isRequired={isStandardRequired}
                        isDisabled={!provinceIdValue}
                        onChange={(selectedOption) => {
                          setValue("districtId", "");
                          setValue("villageId", "");
                        }}
                      />

                      <ControlledReactSelect
                        control={control}
                        name="districtId"
                        label="Kecamatan"
                        options={district?.map((item) => ({ value: item.id, label: item.name }))}
                        isLoading={!district}
                        isRequired={isStandardRequired}
                        isDisabled={!regencyIdValue}
                        onChange={(selectedOption) => {
                          setValue("villageId", "");
                        }}
                      />

                      <ControlledReactSelect
                        control={control}
                        name="villageId"
                        label="Kelurahan"
                        options={village?.map((item) => ({ value: item.id, label: item.name }))}
                        isLoading={!village}
                        isRequired={isStandardRequired}
                        isDisabled={!districtIdValue}
                      />

                      <div className="col-span-2 mt-2">
                        <DynamicLokasiKegiatan 
                           control={control} 
                           fieldName="companyLokasiKegiatan" 
                           errors={errors} 
                           setValue={setValue} 
                           isTidakKelolaB3={tidakMelakukanPengelolaanB3} 
                        />
                      </div>
                    </div>

                    <div className="flex items-center gap-1">
                      <Button isLoading={isSubmitting} isDisabled={isSubmitting} type="submit" color="primary">
                        {isEdit ? "Simpan" : "Tambah"}
                      </Button>
                      <Button isDisabled={isSubmitting} color="danger" variant="faded" onPress={onClose}>
                        Batal
                      </Button>
                    </div>
                  </form>
                )}
              </ModalBody>
              <ModalFooter></ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>

      {/* Modal Dialog untuk Perusahaan Tidak Ditemukan */}
      {!isEdit ? (
        <Modal isOpen={showNotFoundDialog} onClose={() => setShowNotFoundDialog(false)} size="md">
          <ModalContent>
            <ModalHeader className="flex flex-col gap-1">
              <div className="flex items-center gap-2">
                <ExclamationTriangleIcon className="h-6 w-6 text-warning" />
                <span>Perusahaan Tidak Ditemukan</span>
              </div>
            </ModalHeader>
            <ModalBody>
              <p className="text-default-600">Perusahaan dengan NPWP/NIB yang Anda cari tidak ditemukan dalam sistem.</p>
              <p className="text-default-600">Apakah Anda ingin mengisi data perusahaan secara manual?</p>
            </ModalBody>
            <ModalFooter>
              <Button color="default" variant="light" onPress={() => setShowNotFoundDialog(false)}>
                Batal
              </Button>
              <Button color="primary" onPress={handleConfirmManualCreation}>
                Ya, Isi Manual
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      ) : (
        <Modal isOpen={showNotFoundDialog} onClose={() => setShowNotFoundDialog(false)} size="lg">
          <ModalContent>
            <ModalHeader className="flex flex-col gap-1">
              <div className="flex items-center gap-2">
                <ExclamationTriangleIcon className="h-6 w-6 text-warning" />
                <span>Perusahaan Tidak Ditemukan</span>
              </div>
            </ModalHeader>
            <ModalBody>
              <p className="text-default-600">Perusahaan dengan NPWP <strong>({npwpValue})</strong> yang Anda cari tidak ditemukan dalam sistem.</p>
              <p className="text-default-600">Pastikan NPWP yang anda masukkan sesuai dengan NPWP yang terdaftar di PTSP.</p>
            </ModalBody>
            <ModalFooter>
              <Button color="default" variant="light" onPress={() => setShowNotFoundDialog(false)}>
                Kembali
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>        
      )}

    </RootAdmin>
  );
}

function SearchField({ value, onChange, placeholder }) {
  return (
    <div className="flex w-full items-center">
      <div className="w-full sm:w-1/4">
        <input
          type="text"
          id="search"
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          className="w-full px-3 py-2 border border-line-strong rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent"
        />
      </div>
    </div>
  );
}

function DynamicLokasiKegiatan({ control, fieldName, errors, setValue, isTidakKelolaB3 }) {
  const { fields, append, remove } = useFieldArray({ control, name: fieldName });

  return (
    <div>
      <div className="flex flex-col mb-3">
        <div className="flex justify-between items-center">
          <h3 className="text-sm font-medium">Lokasi Kegiatan Operasional</h3>
          <Button
            size="sm"
            startContent={<PlusIcon className="size-4" />}
            onClick={() =>
              append({
                namaLokasiKegiatan: "",
                alamatLokasiKegiatan: "",
                latitude: "",
                longitude: "",
                provinceId: "",
                regencyId: "",
                districtId: "",
                villageId: "",
              })
            }
            color="success"
          >
            Tambah Lokasi Kegiatan
          </Button>
        </div>
        <p className="text-xs text-ink-500 mt-1">Harap masukkan semua lokasi kegiatan yang dimiliki</p>
        {errors.companyLokasiKegiatan && <p className="text-danger text-xs mt-1">{errors.companyLokasiKegiatan.message}</p>}
      </div>

      {fields.length === 0 && (
        <div className="border-2 border-dashed border-line-strong rounded-lg p-6 text-center">
          <p className="text-ink-500 text-sm">Belum ada lokasi kegiatan</p>
          <p className="text-ink-400 text-xs">Klik tombol "Tambah Lokasi Kegiatan" untuk menambahkan</p>
        </div>
      )}

      {fields.length > 0 && fields.map((field, index) => (
        <LokasiKegiatanItem 
          key={field.id} 
          control={control} 
          index={index} 
          fieldName={fieldName} 
          setValue={setValue} 
          onRemove={() => remove(index)} 
          canRemove={true} 
          isTidakKelolaB3={isTidakKelolaB3} 
        />
      ))}
    </div>
  );
}

function LokasiKegiatanItem({ control, index, fieldName, setValue, onRemove, canRemove, isTidakKelolaB3 }) {
  const [sameAsCompany, setSameAsCompany] = useState(false);

  const mainAlamatKantor = useWatch({ control, name: "alamatKantor" });
  const mainLatitude = useWatch({ control, name: "latitude" });
  const mainLongitude = useWatch({ control, name: "longitude" });
  const mainProvinceId = useWatch({ control, name: "provinceId" });
  const mainRegencyId = useWatch({ control, name: "regencyId" });
  const mainDistrictId = useWatch({ control, name: "districtId" });
  const mainVillageId = useWatch({ control, name: "villageId" });

  const { data: lokasiProvince } = useSWR("/api/location/provinces", getFetcher);
  const provinceId = useWatch({ control, name: `${fieldName}[${index}].provinceId` });
  const regencyId = useWatch({ control, name: `${fieldName}[${index}].regencyId` });
  const districtId = useWatch({ control, name: `${fieldName}[${index}].districtId` });

  const { data: lokasiRegency } = useSWR(provinceId ? `/api/location/cities?provinceId=${provinceId}` : null, getFetcher);
  const { data: lokasiDistrict } = useSWR(regencyId ? `/api/location/districts?regencyId=${regencyId}` : null, getFetcher);
  const { data: lokasiVillage } = useSWR(districtId ? `/api/location/villages?districtId=${districtId}` : null, getFetcher);

  const [lokasiLocationData, setLokasiLocationData] = useState(null);
  const [lokasiIsMatchingLocation, setLokasiIsMatchingLocation] = useState(false);

  const findLocationMatch = useCallback((locationArray, searchName) => {
    if (!locationArray || !searchName) return null;

    return locationArray.find((item) => {
      const itemName = item.name.toLowerCase();
      const searchNameLower = searchName.toLowerCase();

      if (itemName === searchNameLower) return true;
      if (itemName.includes(searchNameLower) || searchNameLower.includes(itemName)) return true;

      const cleanItemName = itemName.replace(/^(kota|kabupaten|kab\.?|provinsi|prov\.?)\s+/i, "");
      const cleanSearchName = searchNameLower.replace(/^(kota|kabupaten|kab\.?|provinsi|prov\.?)\s+/i, "");

      return cleanItemName === cleanSearchName || cleanItemName.includes(cleanSearchName) || cleanSearchName.includes(cleanItemName);
    });
  }, []);

  const handleLokasiLocationDataReceived = useCallback(
    (data) => {
      console.log(`[LOKASI ${index}] Received location data:`, data);
      setLokasiLocationData(data);

      setValue(`${fieldName}[${index}].provinceId`, "");
      setValue(`${fieldName}[${index}].regencyId`, "");
      setValue(`${fieldName}[${index}].districtId`, "");
      setValue(`${fieldName}[${index}].villageId`, "");

      setLokasiIsMatchingLocation(true);
    },
    [fieldName, index, setValue],
  );

  useEffect(() => {
    if (lokasiLocationData && lokasiProvince && lokasiProvince.length > 0 && lokasiIsMatchingLocation) {
      const matchedProvince = findLocationMatch(lokasiProvince, lokasiLocationData.province);

      if (matchedProvince) {
        setValue(`${fieldName}[${index}].provinceId`, matchedProvince.id.toString());
      } else {
        setLokasiIsMatchingLocation(false);
      }
    }
  }, [lokasiLocationData, lokasiProvince, lokasiIsMatchingLocation, findLocationMatch, fieldName, index, setValue]);

  useEffect(() => {
    if (lokasiLocationData && lokasiLocationData.regency && lokasiRegency && lokasiRegency.length > 0 && lokasiIsMatchingLocation && provinceId) {
      const matchedRegency = findLocationMatch(lokasiRegency, lokasiLocationData.regency);

      if (matchedRegency) {
        setValue(`${fieldName}[${index}].regencyId`, matchedRegency.id.toString());
        setLokasiIsMatchingLocation(false);
      } else {
        setLokasiIsMatchingLocation(false);
      }
    }
  }, [lokasiLocationData, lokasiRegency, lokasiIsMatchingLocation, provinceId, findLocationMatch, fieldName, index, setValue]);

  const handleSameAsCompany = useCallback(
    (checked) => {
      setSameAsCompany(checked);

      if (checked) {
        setValue(`${fieldName}[${index}].alamatLokasiKegiatan`, mainAlamatKantor || "");
        setValue(`${fieldName}[${index}].latitude`, mainLatitude || "");
        setValue(`${fieldName}[${index}].longitude`, mainLongitude || "");
        setValue(`${fieldName}[${index}].provinceId`, mainProvinceId || "");
        setValue(`${fieldName}[${index}].regencyId`, mainRegencyId || "");
        setValue(`${fieldName}[${index}].districtId`, mainDistrictId || "");
        setValue(`${fieldName}[${index}].villageId`, mainVillageId || "");
      }
    },
    [fieldName, index, setValue, mainAlamatKantor, mainLatitude, mainLongitude, mainProvinceId, mainRegencyId, mainDistrictId, mainVillageId],
  );

  return (
    <Card className="mb-4 p-4" radius="sm">
      <CardBody>
        <div className="flex justify-between items-center mb-3">
          <h4 className="text-sm font-semibold">Lokasi Kegiatan {index + 1}</h4>
          <Button color="danger" size="sm" isIconOnly onClick={onRemove} isDisabled={!canRemove}>
            <TrashIcon className="size-4" />
          </Button>
        </div>

        <Controller control={control} name={`${fieldName}[${index}].id`} render={({ field }) => <input type="hidden" {...field} />} />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          <div className="col-span-2">
            <ControlledInput control={control} name={`${fieldName}[${index}].namaLokasiKegiatan`} label="Nama Lokasi Kegiatan" isRequired={!isTidakKelolaB3} />
          </div>

          <div className="col-span-2">
            <Checkbox isSelected={sameAsCompany} onValueChange={handleSameAsCompany} size="sm">
              <span className="text-sm">Alamat sama dengan perusahaan</span>
            </Checkbox>
          </div>

          <div className="col-span-2">
            <Controller
              control={control}
              name={`${fieldName}[${index}].alamatLokasiKegiatan`}
              render={({ field, fieldState }) => (
                <Textarea
                  {...field}
                  variant="faded"
                  label="Alamat Lokasi Kegiatan"
                  labelPlacement="outside"
                  color={fieldState.error ? "danger" : "default"}
                  isInvalid={!!fieldState.error}
                  errorMessage={fieldState.error?.message}
                  isRequired={!isTidakKelolaB3}
                  isDisabled={sameAsCompany}
                />
              )}
            />
          </div>

          <div className="col-span-2">
            <LocationInputWithPicker
              key={`lokasi-${index}`}
              control={control}
              setValue={setValue}
              latitudeName={`${fieldName}[${index}].latitude`}
              longitudeName={`${fieldName}[${index}].longitude`}
              onLocationDataReceived={handleLokasiLocationDataReceived}
              province={lokasiProvince}
              regency={lokasiRegency}
              district={lokasiDistrict}
              village={lokasiVillage}
              isDisabled={sameAsCompany}
            />
          </div>

          <ControlledReactSelect
            control={control}
            name={`${fieldName}[${index}].provinceId`}
            label="Provinsi"
            options={lokasiProvince?.map((item) => ({ value: item.id, label: item.name }))}
            isLoading={!lokasiProvince}
            isRequired={!isTidakKelolaB3}
            isDisabled={sameAsCompany}
            onChange={(selectedOption) => {
              setValue(`${fieldName}[${index}].regencyId`, "");
              setValue(`${fieldName}[${index}].districtId`, "");
              setValue(`${fieldName}[${index}].villageId`, "");
            }}
          />

          <ControlledReactSelect
            control={control}
            name={`${fieldName}[${index}].regencyId`}
            label="Kabupaten/Kota"
            options={lokasiRegency?.map((item) => ({ value: item.id, label: item.name }))}
            isLoading={!lokasiRegency}
            isRequired={!isTidakKelolaB3}
            isDisabled={!provinceId || sameAsCompany}
            onChange={(selectedOption) => {
              setValue(`${fieldName}[${index}].districtId`, "");
              setValue(`${fieldName}[${index}].villageId`, "");
            }}
          />

          <ControlledReactSelect
            control={control}
            name={`${fieldName}[${index}].districtId`}
            label="Kecamatan"
            options={lokasiDistrict?.map((item) => ({ value: item.id, label: item.name }))}
            isLoading={!lokasiDistrict}
            isRequired={!isTidakKelolaB3}
            isDisabled={!regencyId || sameAsCompany}
            onChange={(selectedOption) => {
              setValue(`${fieldName}[${index}].villageId`, "");
            }}
          />

          <ControlledReactSelect
            control={control}
            name={`${fieldName}[${index}].villageId`}
            label="Kelurahan"
            options={lokasiVillage?.map((item) => ({ value: item.id, label: item.name }))}
            isLoading={!lokasiVillage}
            isRequired={!isTidakKelolaB3}
            isDisabled={!districtId || sameAsCompany}
          />
        </div>
      </CardBody>
    </Card>
  );
}